export default __webpack_public_path__ + "img/bGIzclEk.93ab9977.svg";